import { render, staticRenderFns } from "./Field.vue?vue&type=template&id=5b84e294&"
import script from "./Field.vue?vue&type=script&lang=js&"
export * from "./Field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b84e294')) {
      api.createRecord('5b84e294', component.options)
    } else {
      api.reload('5b84e294', component.options)
    }
    module.hot.accept("./Field.vue?vue&type=template&id=5b84e294&", function () {
      api.rerender('5b84e294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vendor/vue-medialibrary/src/components/Field.vue"
export default component.exports